import React, { useCallback, useEffect, useState } from 'react';
import { Badge, Box } from '@mui/material';
import CalendarMonth from '@mui/icons-material/CalendarMonth';
import { usePermissions, useRedirect, useTranslate } from 'react-admin';
import { fetchPendingReviewSummary } from '../../services/pendingEventsService';
import SidebarMenuLink from './SidebarMenuLink';

/**
 * Upcoming Events:
 * - satıra tık → tüm upcoming
 * - kırmızı badge → bekleyenler
 * - /events-v2/create seçili sayılmaz
 */
const UpcomingEventsMenuLink = () => {
  const translate = useTranslate();
  const { permissions } = usePermissions();
  const redirect = useRedirect();
  const isAdmin = permissions?.crole === 'admin';
  const [total, setTotal] = useState(0);

  const load = useCallback(async () => {
    if (!isAdmin) {
      setTotal(0);
      return;
    }
    try {
      const data = await fetchPendingReviewSummary();
      setTotal(data.total || 0);
    } catch {
      setTotal(0);
    }
  }, [isAdmin]);

  useEffect(() => {
    load();
    if (!isAdmin) return undefined;
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, [load, isAdmin]);

  const icon =
    isAdmin && total > 0 ? (
      <Box
        component="span"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          redirect('/events-v2?view=pending');
        }}
        onMouseDown={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        title="Bekleyen etkinlikler"
        sx={{ display: 'inline-flex', cursor: 'pointer' }}
      >
        <Badge badgeContent={total} color="error" max={99}>
          <CalendarMonth />
        </Badge>
      </Box>
    ) : (
      <CalendarMonth />
    );

  return (
    <SidebarMenuLink
      to="/events-v2"
      primaryText={translate('menu.upcoming_events', 'Upcoming Events')}
      leftIcon={icon}
      style={{ fontSize: 12.5 }}
      isActive={(pathname) =>
        pathname === '/events-v2' ||
        (pathname.startsWith('/events-v2/') && !pathname.startsWith('/events-v2/create'))
      }
    />
  );
};

export default UpcomingEventsMenuLink;
